import React from 'react';
import { Link } from 'react-router-dom';
import { withRouter } from 'react-router';
import LocalizedStrings from 'react-localization';
import PropTypes from 'prop-types';
import img1 from '../img/1.jpg';
import img1Webp from '../img/1.webp';
import img2 from '../img/2.jpg';
import img2Webp from '../img/2.webp';
import imgPolis from '../img/logo_polis_kasko.svg'
import $ from 'jquery';

function Header(props) {
  const strings = new LocalizedStrings({
    ru: {
      private: 'Частным лицам',
      busines: 'Бизнесу',
      contacts: 'Контакты',
      compare: 'Лист сравнения',
      compare2: 'перейти к сравнению',
      nothing: 'Лист сравнения пуст. Вы ничего еще не добавили в сравнения',
      login: 'Войти',
      room: 'Кабинет',
      insurance: 'Страхование',
      osago: 'Автогражданка',
      travel: 'Туристическое страхование',
      credits: 'Кредиты',
      green: 'Зеленая карта',
      gas: 'Газ дешевле',
      from: 'от',
      program: 'Реферальная программа',
      online: 'Кредит на карту',
      lombard: 'Онлайн-ломбард',
      health: 'Страхование жизни и здоровья',
      covid: 'Страхование от COVID-19',
      inverseLeasing: 'Деньги под залог авто',
      forAuto: 'Все для авто',
      gasAndElectricity: 'Газ и электричество',
      credit: 'Кредитные карты',
      platform: 'Платформа для бизнеса',
      became: 'Стать партнером',
      api: 'Документация API',
      rules: 'Правила и условия',
      charity: 'Благотворительность',
      category: 'Категория',
      more: 'еще',
      europe: 'Европа',
      turkish: 'Турция',
      egypt: 'Египет',
      leasing: 'Авто в лизинг',
      shtraf: 'Оплата штрафов',
      repayment: 'Погасить кредит',
    },
    ua: {
      private: 'Приватним особам',
      busines: 'Бізнесу',
      contacts: 'Контакти',
      compare: 'Лист порівняння',
      compare2: 'перейти до порівняння',
      nothing: 'Нічого не додано',
      login: 'Увійти',
      room: 'Кабінет',
      insurance: 'Страхування',
      travel: 'Туристичне страхування',
      credits: 'Кредити',
      osago: 'Автоцивілка',
      green: 'Зелена карта',
      gas: 'Газ дешевше',
      from: 'від',
      program: 'Реферальна програма',
      online: 'Кредит на картку',
      lombard: 'Онлайн-ломбард',
      inverseLeasing: 'Гроші під заставу авто',
      forAuto: 'Все для авто',
      gasAndElectricity: 'Газ та електрика',
      health: "Страхування життя та здоров'я",
      covid: 'Страхування від COVID-19',
      credit: 'Кредитні картки',
      platform: 'Платформа для бізнесу',
      became: 'Стати партнером',
      api: 'Документація API',
      rules: 'Правила та умови',
      charity: 'Благодійність',
      category: 'Категорія',
      more: 'ще',
      europe: 'Європа',
      turkish: 'Турція',
      egypt: 'Єгипет',
      leasing: 'Авто в лізинг',
      shtraf: 'Оплата штрафів',
      repayment: 'Погасити кредит',
    },
  });

  strings.setLanguage(props.locale);

  const cleanCompare = () => {
    props.cleanCompare();
  };

  const redirectToCompare = (e) => {
    e.preventDefault();

    $('#header_compare').removeClass('show');
    $('#main').removeClass('show-compare');

    props.history.push({
      pathname: props.locale === 'ua' ? '/uk/kasko/compare' : '/kasko/compare',
      search: props.location.search
    });
  };

  return (
    <header>
      <div className="header_top">
        <div className="container">
          <div className="row flex_j-space-between">
            <div className="flex">
              <Link to={props.locale === 'ua' ? '/uk/kasko' : '/kasko'}>
                <img className="header-logo" src={imgPolis} alt="POLIS.UA" />
              </Link>
              <nav>
                <ul className="hover_line">
                  <li className="active">
                    <a href="#/"></a>
                    {/*<a href="#/">{strings.private}</a>*/}
                  </li>
                  <li>
                    {/*<a href="#/">{strings.busines}</a>*/}
                  </li>
                </ul>
              </nav>
            </div>
            <div className="flex">
              <a className="contacts" href={props.locale === "ua" ? "https://polis.ua/uk/contacts" : "https://polis.ua/contacts"}>{strings.contacts}</a>
              <div className="language-block">
                <form id="form-language" name="form-language">
                  <button
                    className={props.locale === 'ru' ? 'language-select active' : 'language-select'}
                    name="RU"
                    type="button"
                    onClick={props.setLanguageRU}
                  >
                    RU
                  </button>
                  <button
                    className={props.locale === 'ua' ? 'language-select active' : 'language-select'}
                    name="UA"
                    type="button"
                    onClick={props.setLanguageUA}
                  >
                    UA
                  </button>
                </form>
              </div>
              <div id="header_compare">
                <div className="compare_show">
                  <div className="ico">
                    <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                      <path d="M23.9592 12.2101L23.9388 12.2208L20.4956 3.17235H22.0667C22.3484 3.17235 22.5768 2.93119 22.5768 2.63375C22.5768 2.33631 22.3484 2.09515 22.0667 2.09515H12.4667V0.5386C12.4667 0.241158 12.2383 0 11.9566 0C11.6749 0 11.4465 0.241158 11.4465 0.5386V2.08977H1.85165C1.56995 2.08977 1.34155 2.33092 1.34155 2.62837C1.34155 2.92581 1.56995 3.16697 1.85165 3.16697H3.48905L0.0408077 12.2101C0.0153029 12.2731 0.00146653 12.3408 0 12.4093C0 14.8827 1.89896 16.8878 4.24145 16.8878C6.58393 16.8878 8.48289 14.8827 8.48289 12.4093C8.48142 12.3408 8.46759 12.2731 8.44208 12.2101L4.99894 3.16158H11.4465V19.8151C9.01339 20.009 7.11073 21.5709 7.11073 23.4614C7.11073 23.7588 7.33913 24 7.62083 24H16.2925C16.5742 24 16.8026 23.7588 16.8026 23.4614C16.8026 21.5709 14.8999 20.009 12.4667 19.8151V3.16158H18.9807L15.5579 12.2101C15.5324 12.2731 15.5186 12.3408 15.5171 12.4093C15.5171 14.8827 17.4161 16.8878 19.7586 16.8878C22.101 16.8878 24 14.8827 24 12.4093C23.9985 12.3408 23.9847 12.2731 23.9592 12.2101ZM4.2389 15.8187C2.659 15.8164 1.3135 14.6055 1.061 12.9587H7.39639C7.14517 14.5975 5.81107 15.8059 4.2389 15.8187ZM7.21275 11.8815H1.27524L4.2491 4.06643L7.21275 11.8815ZM15.6905 22.9228H8.21764C8.59511 21.7648 10.1509 20.8707 11.9515 20.8707C13.7522 20.8707 15.3131 21.7648 15.6905 22.9228ZM19.7356 4.07181L22.6993 11.8815H16.7617L19.7356 4.07181ZM19.7356 15.8187V15.8241C18.1618 15.8108 16.8271 14.5996 16.5781 12.9587H22.9135C22.661 14.6055 21.3155 15.8164 19.7356 15.8187Z" fill="#788392" />
                    </svg>
                  </div>
                  <div className="value">
                    {props.compare.length}
                  </div>
                </div>
                <div className="compare-block">
                  <div className="head">
                    <div className="ico">
                      <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
                        <path d="M23.9592 12.2101L23.9388 12.2208L20.4956 3.17235H22.0667C22.3484 3.17235 22.5768 2.93119 22.5768 2.63375C22.5768 2.33631 22.3484 2.09515 22.0667 2.09515H12.4667V0.5386C12.4667 0.241158 12.2383 0 11.9566 0C11.6749 0 11.4465 0.241158 11.4465 0.5386V2.08977H1.85165C1.56995 2.08977 1.34155 2.33092 1.34155 2.62837C1.34155 2.92581 1.56995 3.16697 1.85165 3.16697H3.48905L0.0408077 12.2101C0.0153029 12.2731 0.00146653 12.3408 0 12.4093C0 14.8827 1.89896 16.8878 4.24145 16.8878C6.58393 16.8878 8.48289 14.8827 8.48289 12.4093C8.48142 12.3408 8.46759 12.2731 8.44208 12.2101L4.99894 3.16158H11.4465V19.8151C9.01339 20.009 7.11073 21.5709 7.11073 23.4614C7.11073 23.7588 7.33913 24 7.62083 24H16.2925C16.5742 24 16.8026 23.7588 16.8026 23.4614C16.8026 21.5709 14.8999 20.009 12.4667 19.8151V3.16158H18.9807L15.5579 12.2101C15.5324 12.2731 15.5186 12.3408 15.5171 12.4093C15.5171 14.8827 17.4161 16.8878 19.7586 16.8878C22.101 16.8878 24 14.8827 24 12.4093C23.9985 12.3408 23.9847 12.2731 23.9592 12.2101ZM4.2389 15.8187C2.659 15.8164 1.3135 14.6055 1.061 12.9587H7.39639C7.14517 14.5975 5.81107 15.8059 4.2389 15.8187ZM7.21275 11.8815H1.27524L4.2491 4.06643L7.21275 11.8815ZM15.6905 22.9228H8.21764C8.59511 21.7648 10.1509 20.8707 11.9515 20.8707C13.7522 20.8707 15.3131 21.7648 15.6905 22.9228ZM19.7356 4.07181L22.6993 11.8815H16.7617L19.7356 4.07181ZM19.7356 15.8187V15.8241C18.1618 15.8108 16.8271 14.5996 16.5781 12.9587H22.9135C22.661 14.6055 21.3155 15.8164 19.7356 15.8187Z" fill="#788392" />
                      </svg>
                    </div>
                    <div className="tit">
                      {strings.compare}
                    </div>
                  </div>
                  {props.compare.length > 0
                    && (
                      <a className="list flex" href="#/" onClick={redirectToCompare}>
                        <p>КАСКО ({props.compare.length})</p>
                        <span className="remove" onClick={cleanCompare}>
                          <svg height="18" viewBox="0 0 18 18" width="18" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.00122 1L16.9995 17" stroke="#CCCCCC" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                            <path d="M16.9983 1L0.999999 17" stroke="#CCCCCC" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                          </svg>
                        </span>
                      </a>
                    )}
                  {props.compare.length > 0
                    && (
                      <div className="btn-block">
                        <button className="btn" type="button" onClick={redirectToCompare}><span>{strings.compare2}</span>
                          <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1 1L5 5L1 9" stroke="#0A7E3E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><path d="M1 1L5 5L1 9" stroke="#189851" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
                        </button>
                      </div>
                    )}
                  {props.compare.length === 0
                    && (
                      <div className="empty">
                        {strings.nothing}
                      </div>
                    )}
                </div>
              </div>
              <div id="adaptive_menu">
                <div className="pannel-hide menu-hide" />
                <div className="flex">
                  <div className="menu-ico menu-show">
                    <svg height="12" viewBox="0 0 16 12" width="16">
                      <path d="M1 1H15M1 6H10M1 11H5" stroke="#374656" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                    </svg>
                  </div>
                </div>
                <div className="mmenu">
                  <div className="menu-head flex flex_j-space-between">
                    <img className="header-logo close-menu" src={imgPolis} alt="polis logo" />
                    <div className="flex">
                      <div className="menu-ico menu-hide">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path d="M5.1416 5L19.283 19.1429" stroke="#374656" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                          <path d="M19.1416 5L5.00022 19.1429" stroke="#374656" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div className="menu-body">
                    <div className="m-accordion">
                      <div className="m_accordion-item">
                        <div className="m_accordion-tit flex flex_j-space-between line-block">
                          <div className="tit tit-bold">
                            {strings.private}
                          </div>
                          <div className="ico">
                            <svg width="6" height="10" viewBox="0 0 6 10" fill="none">
                              <path d="M1 1L5 5L1 9" stroke="#374656" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </div>
                        </div>
                        <div className="m_accordion-panel">
                          <ul>
                            <li className="mpanel">
                              <div className="mpanel_link flex flex_j-space-between">
                                <div className="tit">
                                  {strings.insurance}
                                </div>
                                <div className="ico">
                                  <svg width="6" height="10" viewBox="0 0 6 10" fill="none">
                                    <path d="M1 1L5 5L1 9" stroke="#374656" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                  </svg>
                                </div>
                              </div>
                              <div className="mpanel-body">
                                <div className="mpanel-back flex">
                                  <div className="ico">
                                    <svg height="10" viewBox="0 0 6 10" width="6">
                                      <path d="M5 9L1 5L5 1" stroke="#374656" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                                    </svg>
                                  </div>
                                  <div className="tit tit-bold">
                                    {strings.insurance}
                                  </div>
                                </div>
                                <ul>
                                  <li>
                                    <a className="tit" href={props.locale === "ua" ? "https://polis.ua/uk/osago": "https://polis.ua/osago"}>{strings.osago}</a>
                                  </li>
                                  <li>
                                    <a className="tit" href={props.locale === "ua" ? "https://polis.ua/uk/travel": "https://polis.ua/travel"}>{strings.travel}</a>
                                  </li>
                                  <li>
                                    <Link className="tit close-menu" to={props.locale === 'ua' ? '/uk/kasko' : '/kasko'}>КАСКО</Link>
                                  </li>
                                  <li>
                                    <a className="tit" href={props.locale === "ua" ? "https://polis.ua/uk/health": "https://polis.ua/health"}>{strings.health}</a>
                                  </li>
                                </ul>
                                <div className="plans">
                                  <div className="item">
                                    <div className="img">
                                      <a href={props.locale === "ua" ? "https://polis.ua/uk/osago": "https://polis.ua/osago"}>
                                        <picture>
                                          <source srcSet={img1Webp} type="image/webp" />
                                          <img src={img1} alt="osago" />
                                        </picture>
                                      </a>
                                    </div>
                                    <div className="flex flex_j-space-between">
                                      <div className="tit">{strings.osago}</div>
                                      <div className="value">
                                        {strings.from} 600 грн
                                      </div>
                                    </div>
                                  </div>
                                  <div className="item">
                                    <div className="img">
                                      <a href={props.locale === "ua" ? "https://polis.ua/uk/travel": "https://polis.ua/travel"}>
                                        <picture>
                                          <source srcSet={img2Webp} type="image/webp" />
                                          <img src={img2} alt="travel" />
                                        </picture>
                                      </a>
                                    </div>
                                    <div className="flex flex_j-space-between">
                                      <div className="tit">
                                        {strings.europe}, {strings.turkish}, {strings.egypt}
                                      </div>
                                      <div className="value">
                                        {strings.from} 50 грн
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </li>
                            <li className="mpanel">
                              <a className="tit" href={props.locale === "ua" ? "https://polis.ua/uk/shtraf": "https://polis.ua/shtraf"}>{strings.shtraf}</a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="m_accordion-item">
                        <div className="m_accordion-tit flex flex_j-space-between line-block">
                          <div className="tit tit-bold">
                            {strings.busines}
                          </div>
                          <div className="ico">
                            <svg width="6" height="10" viewBox="0 0 6 10" fill="none">
                              <path d="M1 1L5 5L1 9" stroke="#374656" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </div>
                        </div>
                        <div className="m_accordion-panel">
                          <ul>
                            <li>
                              <a className="tit" href={props.locale === "ua" ? "https://polis.ua/uk/b2b": "https://polis.ua/b2b"}>{strings.platform}</a>
                            </li>
                            <li>
                              <a className="tit" href={ props.locale === "ua" ? "https://polis.ua/uk/b2b/api/shema" : "https://polis.ua/b2b/api/shema"}>{strings.api}</a>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <a className="tit tit-bold line-block" href={props.locale === "ua" ? "https://polis.ua/uk/referalna-programa" : "https://polis.ua/referalnaya-programma"}>{strings.program}</a>
                    </div>
                  </div>
                  <div className="menu-footer">
                    <div className="mpanel m-compare">
                      <div className="mpanel_link flex flex_j-space-between line-block">
                        <div className="tit tit-bold">
                          {strings.compare}
                        </div>
                        <div className="compare_ico">
                          <div className="ico">
                            <svg height="24" viewBox="0 0 24 24" width="24">
                              <path d="M23.9592 12.2101L23.9388 12.2208L20.4956 3.17235H22.0667C22.3484 3.17235 22.5768 2.93119 22.5768 2.63375C22.5768 2.33631 22.3484 2.09515 22.0667 2.09515H12.4667V0.5386C12.4667 0.241158 12.2383 0 11.9566 0C11.6749 0 11.4465 0.241158 11.4465 0.5386V2.08977H1.85165C1.56995 2.08977 1.34155 2.33092 1.34155 2.62837C1.34155 2.92581 1.56995 3.16697 1.85165 3.16697H3.48905L0.0408077 12.2101C0.0153029 12.2731 0.00146653 12.3408 0 12.4093C0 14.8827 1.89896 16.8878 4.24145 16.8878C6.58393 16.8878 8.48289 14.8827 8.48289 12.4093C8.48142 12.3408 8.46759 12.2731 8.44208 12.2101L4.99894 3.16158H11.4465V19.8151C9.01339 20.009 7.11073 21.5709 7.11073 23.4614C7.11073 23.7588 7.33913 24 7.62083 24H16.2925C16.5742 24 16.8026 23.7588 16.8026 23.4614C16.8026 21.5709 14.8999 20.009 12.4667 19.8151V3.16158H18.9807L15.5579 12.2101C15.5324 12.2731 15.5186 12.3408 15.5171 12.4093C15.5171 14.8827 17.4161 16.8878 19.7586 16.8878C22.101 16.8878 24 14.8827 24 12.4093C23.9985 12.3408 23.9847 12.2731 23.9592 12.2101ZM4.2389 15.8187C2.659 15.8164 1.3135 14.6055 1.061 12.9587H7.39639C7.14517 14.5975 5.81107 15.8059 4.2389 15.8187ZM7.21275 11.8815H1.27524L4.2491 4.06643L7.21275 11.8815ZM15.6905 22.9228H8.21764C8.59511 21.7648 10.1509 20.8707 11.9515 20.8707C13.7522 20.8707 15.3131 21.7648 15.6905 22.9228ZM19.7356 4.07181L22.6993 11.8815H16.7617L19.7356 4.07181ZM19.7356 15.8187V15.8241C18.1618 15.8108 16.8271 14.5996 16.5781 12.9587H22.9135C22.661 14.6055 21.3155 15.8164 19.7356 15.8187Z" fill="#788392" />
                            </svg>
                          </div>
                          <div className="value">
                            {props.compare.length}
                          </div>
                        </div>
                      </div>
                      <div className="mpanel-body">
                        <div className="mpanel-back flex">
                          <div className="ico">
                            <svg width="6" height="10" viewBox="0 0 6 10" fill="none">
                              <path d="M5 9L1 5L5 1" stroke="#374656" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </div>
                          <div className="tit tit-bold">
                            {strings.compare}
                          </div>
                        </div>
                        {props.compare.length > 0
                          && (
                            <div>
                              <a className="list flex flex_j-space-between" href="#/" onClick={redirectToCompare}>
                                <p>КАСКО ({props.compare.length})</p>
                                <span className="remove" onClick={cleanCompare}>
                                  <svg height="18" viewBox="0 0 18 18" width="18" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.00122 1L16.9995 17" stroke="#CCCCCC" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                                    <path d="M16.9983 1L0.999999 17" stroke="#CCCCCC" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                                  </svg>
                                </span>
                              </a>
                              <div className="btn-block">
                                <button className="btn" type="button" onClick={redirectToCompare}><span style={{ marginRight: '5px' }}>{strings.compare2}</span>
                                  <svg width="6" height="10" viewBox="0 0 6 10" fill="none">
                                    <path d="M1 1L5 5L1 9" stroke="#0A7E3E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><path d="M1 1L5 5L1 9" stroke="#189851" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                  </svg>
                                </button>
                              </div>
                            </div>
                          )}
                        {props.compare.length <= 0
                          && (
                            <div className="empty">
                              {strings.nothing}
                            </div>
                          )}
                      </div>
                    </div>
                    <div className="language-block">
                      <form id="m-form-language" name="m-form-language">
                        <button
                          className={props.locale === 'ru' ? 'language-select active' : 'language-select'}
                          name="RU"
                          type="button"
                          onClick={props.setLanguageRU}
                        >
                          RU
                        </button>
                        <button
                          className={props.locale === 'ua' ? 'language-select active' : 'language-select'}
                          name="UA"
                          type="button"
                          onClick={props.setLanguageUA}
                        >
                          UA
                        </button>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="header_bottom">
        <div className="container">
          <div className="row flex_j-space-between">
            <div id="navigation">
              <div className="main_menu">
                <ul className="navigation-menu">
                  <li className="has-submenu ">
                    <a href="#/">{strings.insurance}
                      <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M9 1L5 5L1 1" stroke="#374656" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </a>
                    <div className="submenu">
                      <div className="container">
                        <div className="row flex_j-space-between">
                          <ul>
                            <li>
                              <a href={props.locale === "ua" ? "https://polis.ua/uk/osago": "https://polis.ua/osago"}>{strings.osago}</a>
                            </li>
                            <li>
                              <a href={props.locale === "ua" ? "https://polis.ua/uk/travel": "https://polis.ua/travel"}>{strings.travel}</a>
                            </li>
                            <li>
                              <Link className="close-menu" to={props.locale === 'ua' ? '/uk/kasko' : '/kasko'}>КАСКО</Link>
                            </li>
                            <li>
                              <a href={props.locale === "ua" ? "https://polis.ua/uk/health": "https://polis.ua/health"}>{strings.health}</a>
                            </li>
                          </ul>
                          <div className="row">
                            <div className="item">
                              <div className="img">
                                <a href={props.locale === "ua" ? "https://polis.ua/uk/osago": "https://polis.ua/osago"}>
                                  <picture>
                                    <source srcSet={img1Webp} type="image/webp" />
                                    <img src={img1} alt="osago" />
                                  </picture>
                                </a>
                              </div>
                              <div className="flex flex_j-space-between">
                                <div className="tit">{strings.osago}</div>
                                <div className="value">
                                  {strings.from} 600 грн
                                </div>
                              </div>
                            </div>
                            <div className="item">
                              <div className="img">
                                <a href={props.locale === "ua" ? "https://polis.ua/uk/travel": "https://polis.ua/travel"}>
                                  <picture>
                                    <source srcSet={img2Webp} type="image/webp" />
                                    <img src={img2} alt="travel" />
                                  </picture>
                                </a>
                              </div>
                              <div className="flex flex_j-space-between">
                                <div className="tit">
                                  {strings.europe}, {strings.turkish},<br />
                                  {strings.egypt}
                                </div>
                                <div className="value">
                                  {strings.from} 50 грн
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </li>
                  <li className="has-submenu ">
                    <a href={props.locale === "ua" ? "https://polis.ua/uk/shtraf": "https://polis.ua/shtraf"}>{strings.shtraf}</a>
                  </li>
                  <li>
                    <a href={props.locale === "ua" ? "https://polis.ua/uk/referalna-programa" : "https://polis.ua/referalnaya-programma"}>{strings.program}</a>
                  </li>
                  <li className="has-submenu menu-more">
                    <a href="#/">{strings.more} <svg height="6" viewBox="0 0 10 6" width="10" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9 1L5 5L1 1" stroke="#374656" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" />
                    </svg>
                    </a>
                    <div className="submenu">
                      <div className="container">
                        <ul>
                          <li>
                            <a href={props.locale === "ua" ? "https://polis.ua/uk/cards": "https://polis.ua/cards"}>{strings.credit}</a>
                          </li>
                          <li>
                            <a href="#/">{strings.category}</a>
                          </li>
                          <li>
                            <a href={props.locale === "ua" ? "https://polis.ua/uk/osago/ref-program" : "https://polis.ua/osago/ref-program"}>{strings.program}</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
Header.propTypes = {
  setLanguageUA: PropTypes.func.isRequired,
  setLanguageRU: PropTypes.func.isRequired,
};

export default withRouter(Header);
